// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CustomersCardsSection_cardContainer__Q626v","cardBox":"CustomersCardsSection_cardBox__mBKtQ"};